import React from 'react';
import { ArrowDownIcon, FileTextIcon } from 'lucide-react';
import { BowMark } from './BowMark';
import { CollectionMockup } from './CollectionMockup';
import { BRAND, GALLERY_ANCHOR } from '../data/collection';
import { primaryButtonClass } from '../utils/buttonStyles';

/**
 * Opening without price. Mobile: brand, title, subtitle, mockup, button, note.
 * Desktop: copy + button on the left, mockup on the right.
 */
export function Hero() {
  return <section id="inicio" aria-labelledby="hero-title" className="w-full bg-ivory" data-id="element-71" data-mp="127eereur1rdz">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-6 px-5 pb-10 pt-6 text-center sm:px-8 sm:pt-10 lg:grid-cols-[minmax(0,1.05fr)_minmax(0,1fr)] lg:grid-rows-[auto_auto] lg:gap-x-12 lg:gap-y-8 lg:pb-24 lg:pt-14 lg:text-left" data-id="element-72" data-mp="xaxfboi3nqll">
        <div className="animate-hero-copy min-w-0 lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-73" data-mp="3d1imxgffvoql">
          <p className="flex items-center justify-center gap-2.5 lg:justify-start lg:gap-3" data-id="element-74" data-mp="382fern45x2ee">
            <BowMark className="h-7 w-10 shrink-0 lg:h-8 lg:w-12" data-id="element-75" data-mp="384s4img5wh20" />
            <span className="font-serif text-[1.5rem] font-semibold italic leading-none text-coral-ink sm:text-[1.8rem] lg:text-[2rem]" data-id="element-76" data-mp="3j923fiwkdgsw">
              {BRAND.name}
            </span>
          </p>
          <p className="mt-1.5 text-[0.95rem] font-semibold text-sage-ink lg:mt-2" data-id="element-77" data-mp="399tex5kgwudx">Moldes Multi-talle de ropa infantil</p>

          <h1 id="hero-title" className="mt-4 font-serif text-[1.9rem] font-semibold leading-[1.1] text-graphite text-balance min-[390px]:text-[2.05rem] sm:text-[2.6rem] lg:mt-6 lg:text-[3.3rem] lg:leading-[1.06]" data-id="element-78" data-mp="3ebipyl7ox820">
            Empezá <span className="text-coral-ink" data-id="element-79" data-mp="2qkwhwtxorns0">tu propio emprendimiento de ropa infantil</span> con 31 modelos
            listos para confeccionar.
          </h1>
          <p className="mx-auto mt-4 max-w-xl text-[1.05rem] leading-relaxed text-graphite-soft text-pretty sm:text-[1.12rem] lg:mx-0 lg:mt-5 lg:text-[1.2rem]" data-id="element-80" data-mp="2hj5drtisnp09">
            Con moldes listos para imprimir en A4, 10 talles por estatura y manuales de confección paso a paso. Ideal
            para principiantes que quieren empezar a crear y vender sus propias prendas.
          </p>
        </div>

        <div className="animate-hero-media min-w-0 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:self-center" data-id="element-81" data-mp="ic873bxiq0w9">
          <CollectionMockup priority className="max-w-[min(270px,100%)] sm:max-w-[360px] lg:max-w-[600px]" data-id="element-82" data-mp="ddf4iejrruav" />
        </div>

        <div className="min-w-0 lg:col-start-1 lg:row-start-2 lg:self-start" data-id="element-83" data-mp="1azul7e4dgnxd">
          <a href={GALLERY_ANCHOR} className={primaryButtonClass('hero')} data-id="element-84" data-mp="161axp9a4r42w">
            Descubrí la colección
            <ArrowDownIcon className="h-4 w-4 shrink-0 transition-transform duration-200 ease-out group-hover:translate-y-0.5" aria-hidden data-id="element-85" data-mp="111ycesywq52f" />
          </a>
          <p className="mt-4 flex items-center justify-center gap-2 text-[0.95rem] font-semibold text-graphite-soft lg:justify-start" data-id="element-86" data-mp="3ltgo5tkf8wpx">
            <FileTextIcon className="h-4 w-4 shrink-0 text-sage-ink" aria-hidden data-id="element-87" data-mp="3hpsen5c8br21" />
            Archivos digitales en PDF: manuales y moldes.
          </p>
        </div>
      </div>
    </section>;
}